import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import moment from "moment-timezone";
import { Button } from "react-bootstrap";
import "./EarthquakeMarkers.css";

export default function EarthquakeMarkersUSGS({
  reEqdata = [],
  compute_magnitudeUSGS,
  getDistance,
  handleShowModal,
  setClickedEventElement,
  setShowLanguageModal,
  markerRefs,
  fetchNearbyCities,
  canSendEmail = false,
  canGenerateBulletin = false,
}) {
  const defaultIcon = L.icon({
    iconUrl: "/Earthquake/recent.png",
    iconSize: [30, 30],
  });
  
  return (
    <>
      {reEqdata.map((eqs, index) => {
        const t = compute_magnitudeUSGS(parseFloat(eqs.magnitude));
        //const distance_each = getDistance(eqs.latitude, eqs.longitude);
        const formattedUTC = moment.utc(eqs.time_in_utc).format("DD MMM YYYY hh:mm:ss A");
        const formattedTLT = moment.utc(eqs.time_in_utc).tz("Asia/Dili").format("DD MMM YYYY hh:mm:ss A");

        const popupContent = (
          <>
            <h2 className="tbTit">
              <a href={eqs.url} target="_blank" rel="noopener noreferrer">{eqs.title}</a>
            </h2>
            Date & Time (UTC): {formattedUTC} <br />
            Date & Time (TLT): {formattedTLT} East Timor Time (TLT) <br />
            Longitude: {eqs.longitude} <br />
            Latitude: {eqs.latitude} <br />
            Magnitude: {eqs.magnitude} {eqs.mag_type} <br />
            Depth: {eqs.depth} km <br />
            Tsunami: {eqs.tsunami ?? "N/A"} <br />
            Felt: {eqs.felt ?? "N/A"} <br />
            CDI: {eqs.cdi ?? "N/A"} <br />
            MMI: {eqs.mmi ?? "N/A"} <br />
            Alert: {eqs.alert ?? "N/A"} <br />
            SIG: {eqs.sig ?? "N/A"} <br /><br />

            {canSendEmail && (
            <Button
              variant="info"
              onClick={handleShowModal}
              data-source="USGS"
              data-reg={eqs.title}
              data-sig={eqs.sig ?? "N/A"}
              data-alert={eqs.alert ?? "N/A"}
              data-mmi={eqs.mmi ?? "N/A"}
              data-cdi={eqs.cdi ?? "N/A"}
              data-felt={eqs.felt ?? "N/A"}
              data-tsunami={eqs.tsunami ?? "N/A"}
              data-depth={eqs.depth}
              data-magt={eqs.mag_type}
              data-magnitude={eqs.magnitude}
              data-title={eqs.title}
              data-utctime={formattedUTC}
              data-tlttime={`${formattedTLT} East Timor Time (TLT)`}
              data-long={eqs.longitude}
              data-lat={eqs.latitude}
              data-info={`Title = ${eqs.title}\nOrigin Time (UTC) = ${formattedUTC}\nOrigin Time (TLT) = ${formattedTLT} East Timor Time (TLT)\nMagnitude = ${eqs.magnitude} ${(eqs.mag_type?.toLowerCase() === "mb" ? "SR" : eqs.mag_type)}\nDepth = ${eqs.depth} km\nLongitude = ${eqs.longitude}\nLatitude = ${eqs.latitude}\nTsunami = ${eqs.tsunami ?? "N/A"}\nFelt = ${eqs.felt ?? "N/A"}\nCDI = ${eqs.cdi ?? "N/A"}\nMMI = ${eqs.mmi ?? "N/A"}\nAlert = ${eqs.alert ?? "N/A"}\nSignificance = ${eqs.sig ?? "N/A"}\nSource = USGS`}
              size="sm"
            >
              Send Email
            </Button>
            )}{" "}

            {canGenerateBulletin && (
            <Button
              variant="success"
              onClick={(e) => {
                setClickedEventElement(e.currentTarget);
                setShowLanguageModal(true);
              }}
              data-source="USGS"
              data-title={eqs.title}
              data-utctime={formattedUTC}
              data-tlttime={`${formattedTLT} East Timor Time (TLT)`}
              data-long={eqs.longitude}
              data-lat={eqs.latitude}
              data-depth={eqs.depth}
              data-magnitude={eqs.magnitude}
              data-magt={eqs.mag_type}
              data-sig={eqs.sig ?? "N/A"}
              data-alert={eqs.alert ?? "N/A"}
              data-mmi={eqs.mmi ?? "N/A"}
              data-cdi={eqs.cdi ?? "N/A"}
              data-felt={eqs.felt ?? "N/A"}
              className="bulletin-btn"
              size="sm"
            >
              Bulletin
            </Button>
            )}{" "}

            <Button
              variant="primary"
              onClick={(e) => fetchNearbyCities(e.target.getAttribute("data-eventid"))}
              data-eventid={eqs.event_id}
              className="bulletin-btn text-white rounded shadow"
              size="sm"
            >
              Nearby Cities
            </Button>
          </>
        );

        if (index === 0) {
          return (
            <Marker
              key={index}
              position={[eqs.latitude, eqs.longitude]}
              icon={defaultIcon}
              ref={(el) => (markerRefs.current[index] = el)}
            >
              <Popup className="custom-popup-class">{popupContent}</Popup>
            </Marker>
          );
        }

        return (
          <Marker
            key={index}
            position={[eqs.latitude, eqs.longitude]}
            icon={L.divIcon({
              className: "animated-circle-icon",
              html: `
                <div class="circle-container-eq" style="--circle-color: ${t.color}">
                  <div class="pulse-ring-eq"></div>
                  <div class="circle-center-eq">${eqs.magnitude.toFixed(1)}</div>
                </div>
              `,
              iconSize: [40, 40],
              iconAnchor: [20, 20],
            })}
            ref={(el) => (markerRefs.current[index] = el)}
          >
            <Popup className="custom-popup-class">{popupContent}</Popup>
          </Marker>
        );
      })}
    </>
  );
}
